import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white min-h-[60vh]">
            <div className="max-w-4xl mx-auto px-4 py-12 text-center">
                <h1 className="md:text-9xl text-6xl font-bold mb-4">404</h1>
                <h2 className="md:text-3xl text-xl font-semibold mb-4">{t("notFound.title")}</h2>
                <p className="md:text-lg text-sm text-gray-600 mb-8">{t("notFound.description")}</p>
                <Link
                    to="/"
                    className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-purple-600 transition-colors"
                >
                    {t("notFound.returnHome")}
                </Link>
            </div>
        </div>
    );
};

export default NotFoundPage;
